<div *ngIf="message !== ''" [ngClass]="{
       'error': bannerType === 'error', 
       'warning': bannerType === 'warning', 
       'alert': bannerType === 'alert'
     }" class="error-container">
    <div>
        <span class="error-message" [ngClass]="bannerType">{{ message }}</span>
    </div>
    <!-- todo these all type are static ,it can be change in future -->
    <!-- Error -->
    <button *ngIf="bannerType === 'error'" class="error-button error" (click)="handleButtonClick()">
        <span class="error-btn-text error">Reload</span>
    </button>
    <!-- Warning -->
    <button *ngIf="bannerType === 'warning'" class="error-button warning" (click)="handleButtonClick()">
        <span class="error-btn-text warning">Refresh</span>
    </button>
    <!-- Alert -->
    <div *ngIf="bannerType === 'alert'" class="alert-buttons">
        <button class="error-button alert" (click)="handleOk()">
            <span class="error-btn-text alert">OK</span>
        </button>
        <button class="error-button alert" (click)="cancelAction()">
            <span class="error-btn-text alert">Cancel</span>
        </button>
    </div>
</div>